module.exports = __webpack_public_path__ + "8ff300d57db997c168545a7db88a677a.glb";